import React from 'react'
import * as joda from '@js-joda/core'
import { CalendarBaseProps } from 'primereact/calendar'
import EditableField from './EditableField'

export type EditableCalendarProps = {
  value   :joda.LocalDate | null
  onChange:(_:joda.LocalDate | null) => void
  label   :string
  errors  :string | undefined
} & {
  maxDate?:joda.LocalDate
} & Omit<CalendarBaseProps,'maxDate'> // TODO: omit and replace other Date-related properties

export const EditableCalendar : React.FC<EditableCalendarProps> = (props) => {
  return <EditableField
    type="date"
    onChange={(x) => props.onChange(x ? joda.LocalDate.parse(x) : null)}
    label={props.label}
    value={props.value === null ? '' : props.value.toString()}
    errors={props.errors}
    max={props.maxDate === undefined ? undefined : props.maxDate.toString()}
  />
  /*
  return (
    <div className="flex-grow-1">
      <FloatLabel>
        <Calendar
          {...{
            ...props,
            'value':props.value === null ? null : jsjoda.convert(props.value).toDate(),
            'onChange':(e) => {
              props.onChange(e.value === null ? null : jsjoda.nativeJs(e.value).toLocalDate())
            },
            'maxDate':props.maxDate && jsjoda.convert(props.maxDate).toDate(),
          }}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </FloatLabel>
      {!!props.errors && <small id={props.id + '-error'} className="text-danger">{props.errors}</small>}
    </div>
  )
  */
}
